<template>
  <div class="notfound-bd">
    <div>
      <img src="../../images/layout/404.png" alt="" />
    </div>
    <p>{{ $t('login_notfound.ymwzdoqjcnsrdwzsfzq') }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
.notfound-bd {
  text-align: center;
  img {
    display: inline-block;
    width: 600px;
    margin-left: 100px;
    margin-top: 120px;
  }
  p {
    font-size: 15px;
    color: #808080;
    margin-top: 50px;
  }
}
</style>
